export class SpinWheelFilterEntity {
  searchWord?: string
  validFrom?: string
  validTo?: string
  userId?: string
  isPrimary?: boolean
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
